import React from 'react';
import { useEffect, useState } from 'react';
import { getPlans } from '../../services/planService';

function AvailableSubscription() {
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPlans()
            .then((response) => {
                setPlans(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen text-xl text-gray-300">
                Loading...
            </div>
        );
    }
    console.log('Plans:', plans);
    return (
        <div className="p-6 bg-gray-800 text-gray-300 rounded-lg shadow-lg">
            <h2 className="mb-4 text-2xl font-bold text-white">Available Plans</h2>

            {/* List all available plans */}
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {plans.map((plan) => (
                    <div key={plan.id} className="bg-gray-700 rounded-lg p-4 shadow-md">
                        <h3 className="text-lg font-bold text-white">{plan.name}</h3>
                        <p className="text-sm text-gray-400"><span className="font-bold">Price: </span>{plan.price}</p>
                        <p className="text-sm text-gray-400"><span className="font-bold">Duration: </span>{plan.billing_interval}</p>
                        <p className="text-sm text-gray-400"><span className="font-bold">Description: </span>{plan.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default AvailableSubscription;